var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTextalignleft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.7002 1.87402H18.2939C18.7334 1.87402 19.085 1.53125 19.085 1.0918C19.085 0.661133 18.7334 0.30957 18.2939 0.30957H1.7002C1.26074 0.30957 0.917969 0.661133 0.917969 1.0918C0.917969 1.53125 1.26074 1.87402 1.7002 1.87402ZM1.7002 6.47949H11.5527C11.9922 6.47949 12.3438 6.13672 12.3438 5.69727C12.3438 5.25781 11.9922 4.91504 11.5527 4.91504H1.7002C1.26074 4.91504 0.917969 5.25781 0.917969 5.69727C0.917969 6.13672 1.26074 6.47949 1.7002 6.47949ZM1.7002 11.085H18.2939C18.7334 11.085 19.085 10.7422 19.085 10.3027C19.085 9.86328 18.7334 9.52051 18.2939 9.52051H1.7002C1.26074 9.52051 0.917969 9.86328 0.917969 10.3027C0.917969 10.7422 1.26074 11.085 1.7002 11.085ZM1.7002 15.6904H11.5527C11.9922 15.6904 12.3438 15.3389 12.3438 14.9082C12.3438 14.4688 11.9922 14.126 11.5527 14.126H1.7002C1.26074 14.126 0.917969 14.4688 0.917969 14.9082C0.917969 15.3389 1.26074 15.6904 1.7002 15.6904Z",
    fill: "#1C1C1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextalignleft);
export default __webpack_public_path__ + "static/media/text.alignleft.9b1d63c880666821130035bb218af145.svg";
export { ForwardRef as ReactComponent };